<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/S3lc4K/tc-custom/9781398413153.jpg?1705056298616" alt="This image is the cover for the book A Spring Tale"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">A Spring Tale
      </h1>
      <p class="bookDescription body article font2">
        <p>With the cold and dark days of winter far behind now, the wonderful smell of spring in the air and the warmth from the sun’s rays, the first wild daffodils starting to unfold their bright yellow flowers, the smell of the primroses, the carpets of wood anemones, the bright yellow celandines, the smell from the wild violets to name but a few, just filled your heart with joy. Read on to find out the many wonders that spring time can bring.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Christopher Hayes-Brown
      </h2>
      
      <p class="authorDescription body article">Christopher Hayes-Brown is an accountant by profession, a wildlife conservationist at heart and subscribes to various animal charities along with helping to support cancer, arthritis, heart, and war veterans' charities. He loves gardening, and growing exotic plants, has various pets, enjoys writing and loves music, cinema and theatre. He has a fascination for ancient history, human cultures, traditions, religions and beliefs. He is a student of Lau Gar Kung Fu and interested in all forms of the martial arts, fascinated too by evolution, green technologies and magic. "My view," he says, "is to look after others as you would like to be looked after yourself, be a good custodian to all living things and the well-being of the planet. "If my books can give others enjoyment, a laugh, hope, to be compassionate and caring towards others and our wonderful wildlife and habitats, then I am a happy man."</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?ea7641dc